const uaParser = new (require('ua-parser-js'))();
let browser = uaParser.getBrowser();
let isIE = browser && browser.name ? browser.name.toLowerCase() === 'ie' : false;
let isEdge = browser && browser.name ? browser.name.toLowerCase() === 'edge' : false;

const downloadCSV = (rows, fileName) => {
	// CSV Metadata
	let meta = 'data:text/csv;charset=utf-8,';
	let data = '';
	let defaultFileName = 'export-data.csv';

	// Convert array of arrays to CSV string
	if (rows && rows.length) {
		data += rows
			.map(r => {
				return r
					.map(value => {
						if (String(value).indexOf(',') !== -1) {
							value = value.replace(/\"/g, '""');
							return '"' + value + '"';
						}
						return value;
					})
					.join(',');
			})
			.join('\r\n');
	}

	// IE does not support the "download" property on anchor tags
	if (isIE || isEdge) {
		// window.open(encodedUri);
		var blob = new Blob([data], {
			type: meta
		});

		if (navigator.msSaveBlob) {
			navigator.msSaveBlob(blob, fileName || defaultFileName);
		}
	} else {
		// Encode for downloading
		let encodedUri = meta + encodeURIComponent(data);

		let downloadLink = document.createElement('a');
		downloadLink.href = encodedUri;
		downloadLink.download = fileName || defaultFileName;

		document.body.appendChild(downloadLink);
		downloadLink.click();
		document.body.removeChild(downloadLink);
	}
};

module.exports = {
	downloadCSV
};
